<template>
  <modal :show="showModal" @close="cancel" :modal-height="modalHeight" :modal-width="modalWidth">
    <div class="row">
      <span class="color-header">{{ $t('views.switch.resetstatus.header') }} {{ $t('views.switch')}} {{ railObjectName }}</span>
    </div>
    <div class="row">
      <span class="warntext">
        {{ $t('views.switch.resetstatus.warntext')}}
      </span>
    </div>
    <div class="row">
      <div class="infotext" v-html="infoText"></div>
    </div>
    <div class="row">
    </div>
    <div class="row">
      <form class="col s12">
        <div class="row">
          <div class="col s8 offset-s2">
            <div class="input-field col s12">
              <textarea id="textarea1" :placeholder="$t('views.switch.logentry.header')" v-model="logtext" class="materialize-textarea resetstatus-textarea" rows="10" data-length="600"></textarea>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="row no-margin-bottom valign-wrapper">
        <div class="col s6 center-align">
          <a  @click="save()"
            class="waves-effect waves-light btn buttonbg NORMAL" style="padding-top: 10px">
              {{ $t('views.switch.resetstatus.buttonreset') }}
          </a>
        </div>
        <div class="col s6 center-align">
          <a class="button-label-primary" @click="cancel()">{{ $t('cancel') }}</a>
        </div>
    </div>
    <div class="row" v-if="showError">
      <div class="col s12  center-align text-danger">
        {{ error }}
      </div>
    </div>
  </modal>
</template>
<script>
import modal from './modal'
import Translation from '../../i18n/Translation'
import switchApi from '../../services/api/switch/SwitchApi'
import RailObjectService from '../../services/RailObjectService'
import moment from 'moment'

export default {
  name: 'ResetStatus',
  props: {
    switchObject: {
      type: Object,
      default: () => {}
    },
    monitorStatusId: {
      type: Number,
      default: null
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      modalHeight: 400,
      modalWidth: 300,
      logtext: '',
      updateObject: {
        RailObjectId: null,
        LogMessage: null,
        MonitorStatusId: null,
        DateTimeUpdated: null
      },
      error: this.$t('views.switch.update.error'),
      showError: false
    }
  },
  computed: {
    railObjectName: function () {
      if (this.switchObject) {
        return this.switchObject.Name
      } else {
        return ''
      }
    },
    infoText: function () {
      var value = this.$t('views.switch.resetstatus.infotext')
      var warntext = '<i>' + this.$t('warning').toLowerCase() + '</i>'
      var errortext = '<i>' + this.$t('error').toLowerCase() + '</i>'
      var acceptabletext = '<i>' + this.$t('acceptable').toLowerCase() + '</i>'
      var idxalarm = value.indexOf('3')
      var idxwarn = value.indexOf('2')
      var idxaccpetable = value.indexOf('1')
      // An 3 or 2 status of an object will be reverted after 5 1 measurements
      var result = value.substring(0, idxalarm)
      result += errortext + ' ' + value.substring(idxalarm + 1, idxwarn) + ' '
      result += warntext + ' ' + value.substring(idxwarn + 1, idxaccpetable) + ' '
      result += acceptabletext + ' ' + value.substring(idxaccpetable + 1, value.length)
      return result
    }
  },
  components: {
    modal,
    Translation
  },
  methods: {
    save: function () {
      // TO DO  db update log and monitor status
      this.updateObject.RailObjectId = this.switchObject.RailObjectId
      this.updateObject.LogMessage = this.logtext
      if (this.updateObject.LogMessage.trim() === '') {
        this.updateObject.LogMessage = this.$t('views.switch.reset.manual')
      }
      this.updateObject.MonitorStatusId = 1
      this.updateObject.DateTimeUpdated = moment().toISOString(true)
      switchApi.resetMonitorStatus(this.updateObject)
        .then(response => {
          // this.$emit('update:lastMaintenanceDate', this.newMaintenanceDate)
          // // var globalRobj = RailObjectService.getRailObjectByRailObjectId(this.switchObject.RailObjectId)
          // // globalRobj.MonitorStatusId = 1
          this.switchObject.MonitorStatusId = 1
          // RailObjectService.updateRailObject(this.switchObject)
          RailObjectService.updateRailObjectProperty(this.switchObject, 'MonitorStatusId')
          this.$emit('update:switchObject', this.switchObject)
          this.clear()
          this.$emit('update:showModal', false)
        })
        .catch(e => {
          console.log('error updateing last maintenance date', e)
          this.showError = true
        })
      // this.$emit('update:monitorStatusId', 1)
      // this.$emit('update:showModal', false)
    },
    clear: function () {
      this.logtext = ''
      this.showError = false
    },
    cancel: function () {
      this.clear()
      this.$emit('update:showModal', false)
    }
  }
}
</script>
<style scoped>
.modal-mask {
    all: unset;
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: table;
  }

  .modal-container {
    width: 400px !important;
    height: 350px !important;
  }

  .warntext {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    line-height: 20px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
  }
  .infotext {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    line-height: 20px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.56);
  }
  .buttonbg {
    background: #56CCF2;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12);
    border-radius: 2px;
  }
  .NORMAL {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    font-size: 14px;
    text-align: center;
    letter-spacing: 0.0357143em;
    color: #FFFFFF;
  }
  .logheader {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    line-height: 12px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.54);
  }
  .button-label-primary {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    font-size: 12px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: #56CCF2;
    cursor: pointer;
  }
  .resetstatus-textarea {
    height: 50px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/switch/ResetStatus.vue